// utils/imageUtils.js (shared with DeliveryDriver)
/**
 * Compress an image file or blob
 * @param {File|Blob} file - The image to compress
 * @param {number} quality - Quality from 0.0 to 1.0 (default: 0.6)
 * @param {number} maxWidth - Maximum width in pixels (default: 1000)
 * @param {number} maxHeight - Maximum height in pixels (default: 1000)
 * @returns {Promise<Blob>} Compressed image blob
 */
export function compressImage(file, quality = 0.6, maxWidth = 1000, maxHeight = 1000) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;

        // Maintain aspect ratio while respecting max dimensions
        if (width > height) {
          if (width > maxWidth) {
            height = Math.round((height * maxWidth) / width);
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = Math.round((width * maxHeight) / height);
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        // Convert canvas to blob
        canvas.toBlob(
          (blob) => {
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error('Compression failed'));
            }
          },
          'image/jpeg',
          quality
        );
      };

      img.onerror = (error) => reject(error);
    };

    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
}